const hasText = (value) => Boolean(String(value ?? '').trim());

const parseFormData = (formData) => {
  if (!formData) return null;
  if (typeof formData === 'object') return formData;
  try {
    const parsed = JSON.parse(formData);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

export const isSubmittedJobApplication = (app) => {
  if (!app || app.id == null) return false;

  const firstName = String(app.first_name ?? '').trim();
  const lastName = String(app.last_name ?? '').trim();
  const fullName = String(app.name ?? app.full_name ?? '').trim();
  const email = String(app.email ?? '').trim();
  const position = String(app.position ?? '').trim();
  const resume = String(app.resume_file ?? '').trim();
  const formData = parseFormData(app.form_data);
  const submittedAt = String(app.submitted_at ?? app.date_of_application ?? '').trim();

  const hasApplicantIdentity = Boolean(firstName || lastName || fullName);
  const hasPosition = hasText(position) && position.toLowerCase() !== 'not specified';
  const hasResume = hasText(resume);
  const hasSubmittedAt = hasText(submittedAt);
  const hasMeaningfulFormData = Boolean(
    formData && Object.keys(formData).some((key) => {
      const value = formData[key];
      if (value == null) return false;
      if (typeof value === 'string') return value.trim() !== '';
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return Object.keys(value).length > 0;
      return true;
    })
  );

  return (
    hasApplicantIdentity
    && hasText(email)
    && (hasPosition || hasResume || hasSubmittedAt || hasMeaningfulFormData)
  );
};

export const filterSubmittedJobApplications = (applications = []) =>
  (Array.isArray(applications) ? applications : []).filter(isSubmittedJobApplication);
